import { render, staticRenderFns } from "./Airport.vue?vue&type=template&id=1986f242&scoped=true&"
import script from "./Airport.vue?vue&type=script&lang=js&"
export * from "./Airport.vue?vue&type=script&lang=js&"
import style0 from "./Airport.vue?vue&type=style&index=0&id=1986f242&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1986f242",
  null
  
)

export default component.exports